import { z } from "zod";

export const SectionTypeEnum = z.enum(["EMPLOYEE", "MANAGER", "HR"]);
export type SectionType = z.infer<typeof SectionTypeEnum>;

export const ProbationAnswerSchema = z.object({
    reviewId: z.number(),
    answer: z.string()
})

export const ProbationExtensionPeriodSchema = z.object({
    amount: z.number().min(1, "Probation extension period must be at least 1"),
    unit: z.enum(["day", "month"]),
});

export type ProbationExtensionPeriod = z.infer<typeof ProbationExtensionPeriodSchema>;

export const ProbationFormSchema = z.object({
  answers: z.array(
    z.object({
      reviewId: z.number(),
      answer: z.union([
        // Logic for Text/Radio
        z.string().trim().min(1, { message: "This field is required" }),
        // Logic for Checkboxes (Validates the actual Array state)
        z.array(z.string()).min(1, { message: "Select at least one option" }),
      ]),
    }),
  ),
  extensionPeriod: ProbationExtensionPeriodSchema.optional(),
});

export type ProbationForm = z.infer<typeof ProbationFormSchema>;

export const ProbationFormPayloadSchema = z.object({
    cycleId: z.number(),
    sectionType: SectionTypeEnum,
    answers: z.array(ProbationAnswerSchema),
    extensionDays: z.number().optional(),
})

export type ProbationFormPayload = z.infer<typeof ProbationFormPayloadSchema>;